import { Component, Host, h, Prop } from '@stencil/core';
import { E_SEW_WS_PARAGRAPH_SIZE } from './sew-ws-paragraph.types';

@Component({
    tag: 'sew-ws-paragraph',
    styleUrl: 'sew-ws-paragraph.scss',
    shadow: true,
})
export class SewWsParagraph {
    /**
     * paragraph size
     */
    @Prop() size: E_SEW_WS_PARAGRAPH_SIZE = E_SEW_WS_PARAGRAPH_SIZE.M;

    /**
     * bold toggle
     */
    @Prop() bold = false;

    render() {
        return (
            <Host>
                <p class={{ [E_SEW_WS_PARAGRAPH_SIZE[this.size].toLowerCase()]: true, bold: this.bold }}>
                    <slot></slot>
                </p>
            </Host>
        );
    }
}
